import http from 'hub-http/clients/apiClient';
const GLOBAL_HOME_API_BASE = 'global-home-api/eligible/v1';
export function isEligibleForGlobalHome() {
  return http.get(`${GLOBAL_HOME_API_BASE}/eligible`);
}